import { IProductState } from './interface/IProductState'

export const initialState: IProductState = {
  list: undefined,
  loading: false,
  error: undefined,
}
